// extracted by mini-css-extract-plugin
export default {"navBtnBack":"NavigationButtons_navBtnBack__my7c5","navBtn":"NavigationButtons_navBtn__qUM8W"};